import React, { useContext, useEffect, useState } from "react";
import PageHeader from "../Header/PageHeader";
import { useParams, useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../Network/apiCallGateway";
import { DataContext } from "../context/DataContext";
import { sharePWSchemaObj } from "../Validation/PasswordValidation";
import { sweetAlert } from "../Utils/SweetAlert";
import { useFormik } from "formik";
import PasswordForm from "../Components/Modal/PasswordForm";
import PasswordHelper from "../Password/PasswordHelper";
import {
  validationSchema,
  getType,
  upperCase,
  lowerCase,
  numbers,
  symbols,
} from "../Utils/CommonFunction";
import ImportCSV from "../Components/Modal/ImportCSV";
import NoData from "../Components/NoData";
import {
  addFolderschema,
  sharefolderSchemaObj,
} from "../Validation/FolderValidation";
import ShareModal from "../Components/Modal/ShareModal";
import AddFolderModal from "../Components/Modal/AddFolderModal";
import ConfirmModal from "../Components/Modal/ConfirmModal";

function EnvironmentDetails() {
  const {
    selectedUsers,
    setBrudCrumb,
    handleSelectAll,
    setSelectedItems,
    getEnvAccessList,
    setSelectedUsers,
    adminViewUser,
    setLoader,
  } = useContext(DataContext);
  const { envId } = useParams();
  const history = useHistory();

  const [viewType, setViewType] = useState("list");
  const [page, setPage] = useState(1);
  const [folderId, setFolderId] = useState("");
  const [pwDetails, setpwDetails] = useState({});
  const [shareModal, setShareModal] = useState(false);
  const [csvModal, setCsvModal] = useState(false);
  const [passwordId, setpasswordId] = useState("");
  const [passwordEdit, setPasswordEdit] = useState(false);
  const [passwordLength, setPasswordLength] = useState(8);
  const [uppercaseCheck, setUppercaseCheck] = useState(true);
  const [lowercaseCheck, setLowercaseCheck] = useState(true);
  const [numberCheck, setNumberCheck] = useState(true);
  const [symbolCheck, setSymbolCheck] = useState(true);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [generatePassVisible, setGeneratePassVisible] =
    useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [passwordType, setPasswordType] = useState("APIs");
  const [passwordModal, setPasswordModal] = useState(false);
  const [filename, setFilename] = useState("");
  const [secretFile, setSecretFile] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [addFolderModal, setAddFolderModal] = useState(false);
  const [envDetais, setEnvDetails] = useState({});

  const sharetoggle = () => setShareModal(!shareModal);
  const toggleGeneratePass = () =>
    setGeneratePassVisible(!generatePassVisible);
  const togglePassword = () => setPasswordVisible(!passwordVisible);
  const passwordModeltoggle = () => setPasswordModal(!passwordModal);
  const csvModaltoggle = () => setCsvModal(!csvModal);
  const confirmtoggle = () => setConfirmModal(!confirmModal);
  const addFoldertoggle = () => setAddFolderModal(!addFolderModal);

  const { data: envDetails, refetch: detailsRefetch } = useQuery({
    queryKey: ["envdetails" + envId],
    queryFn: async () => {
      const res = await ApiCallGateway.folder.getAFoldersDetails(
        envId,
        adminViewUser?._id || null
      );
      if (res?.status === 200) {
        return res?.data[0];
      } else {
        return [];
      }
    },
  });

  const passwordFormik = useFormik({
    initialValues: validationSchema(
      passwordType,
      pwDetails,
      passwordEdit
    ).initial,
    validationSchema: validationSchema(
      passwordType,
      pwDetails,
      passwordEdit
    ).schma,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let pwExpiryDate = values?.pwExpiryDate;

      delete values?.pwExpiryDate;

      values = {
        ...values,
        pwExpiryDate: pwExpiryDate ? pwExpiryDate : null,
      };
      let res;
      if (passwordEdit) {
        // console.log(JSON.stringify(values), pwDetails?._id);
        if (
          values?.password === "XXXXXXXXXXXXX" ||
          values?.apiSecret === "XXXXXXXXXXXXX"
        ) {
          delete values?.apiSecret;
          delete values?.password;
        }
        if (
          values?.passwordType === "APIs" ||
          values?.passwordType === "Cloud Services"
        ) {
          if (secretFile)
            values = {
              ...values,
              filename: filename,
              secretFile: secretFile,
            };
        }
        res = await ApiCallGateway.password.updatePassword(
          JSON.stringify(values),
          pwDetails?._id
        );
        passwordModeltoggle();
        setPasswordEdit(false);
      } else {
        if (
          values?.passwordType === "APIs" ||
          values?.passwordType === "Cloud Services"
        ) {
          if (secretFile)
            values = {
              ...values,
              filename: filename,
              secretFile: secretFile,
            };
        }
        // change values folderId field value
        values = {
          ...values,
          folderId: envDetails?.folderId,

          envId: envDetails?._id,
        };
        console.log(values);

        res = await ApiCallGateway.password.createPassword(
          JSON.stringify(values)
        );
        passwordModeltoggle();
      }

      // console.log(res);
      passwordRefetch();
      resetForm();
    },
  });

  const sharePasswordFormik = useFormik({
    initialValues: {
      passwordId: "",
      shareWith: [],
      expiryDate: "",
      permissionType: "",
      note: "",
    },
    validationSchema: sharePWSchemaObj,
    onSubmit: async (values, { resetForm }) => {
      let data = [];
      // console.log({ ...values, shareWith: selectedUsers });
      for (const element of selectedUsers) {
        let a = {
          passwordId: values.passwordId,
          shareWith: element?._id,
          sharedEmail: element?.name,
          expiryDate: values.expiryDate,
          permissionType: values.permissionType,
          note: values.note,
        };
        data.push(a);
      }
      // console.log(data);
      const res = await ApiCallGateway.password.sharePassword(data);
      // console.log(res);
      resetForm();
    },
  });

  const {
    isLoading: passwordLoading,
    data: passwordList,
    refetch: passwordRefetch,
  } = useQuery({
    queryKey: [envId],
    queryFn: async () => {
      const res = await ApiCallGateway.password.getEnvPasswords(
        envId
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });
  useEffect(() => {
    setSelectedItems([]);
    passwordRefetch();
  }, []);
  useEffect(() => {
    if (generatePassVisible)
      generatePassword(
        uppercaseCheck,
        lowercaseCheck,
        numberCheck,
        symbolCheck
      );
  }, [
    symbolCheck,
    uppercaseCheck,
    numberCheck,
    lowercaseCheck,
    passwordLength,
    generatePassVisible,
  ]);

  // console.log(passwordList);

  const isOpChecked = (param) => {
    let pw;
    if (param === "numbers") {
      pw = numbers();
      return { isChecked: numberCheck, pwGen: pw };
    }
    if (param === "upperCase") {
      pw = upperCase();
      return { isChecked: uppercaseCheck, pwGen: pw };
    }
    if (param === "symbols") {
      pw = symbols();
      return { isChecked: symbolCheck, pwGen: pw };
    }
    if (param === "lowerCase") {
      pw = lowerCase();
      return { isChecked: lowercaseCheck, pwGen: pw };
    }
  };

  async function generatePassword(
    uppercaseCheck,
    lowercaseCheck,
    numberCheck,
    symbolCheck
  ) {
    const symbols = symbolCheck ? 1 : 0;
    const numbers = numberCheck ? 1 : 0;
    const lowercase = lowercaseCheck ? 1 : 0;
    const uppercase = uppercaseCheck ? 1 : 0;
    if (numbers + symbols + uppercase + lowercase === 0) {
      return sweetAlert(
        "Oops!",
        "No box chosen. Please select at least one box!",
        "error"
      );
    }

    let pw = "";

    while (pw.length < passwordLength) {
      let num = Math.floor(Math.random() * getType.length);
      let typeAdder = getType[num];
      let status = isOpChecked(typeAdder);
      if (status?.isChecked) {
        pw += status?.pwGen;
      }
    }
    // setPassword(pw);
    passwordFormik.setFieldValue("password", pw);

    // onGeneratePw(pw);
  }
  async function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file);
      setSecretFile(file);
      setFilename(file?.name);
    });
  }

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    console.log(file);
    try {
      const base64String = await getBase64(file);
      setFilename(file?.name);

      setSecretFile(base64String);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCSVFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };
  function downloadCSVWithHeaders(passwordType) {
    let headers;
    if (passwordType === "APIs") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "apikey",
        "apiSecret",
        "note",
      ];
    } else if (passwordType === "Database Access") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "port",
        "dbconnectionStrings",
        "username",
        "password",
        "note",
      ];
    } else if (passwordType === "Web Applications") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "username",
        "password",
        "note",
      ];
    } else if (passwordType === "Server Access") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "port",
        "username",
        "password",
        "note",
      ];
    } else if (passwordType === "Cloud Services") {
      headers = [
        "identifier",
        "platform",
        "passwordType",
        "username",
        "password",
        "note",
      ];
    } else if (passwordType === "Others") {
      headers = ["identifier", "other"];
    }

    const csvContent = headers?.join(",") + "\r\n";
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "sample_creandential.csv";

    link.click();
  }
  const processCSV = async (str, delim = ",") => {
    const headers = str.slice(0, str.indexOf("\n")).split(delim);
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");

    let newArray = [];
    rows.map((row) => {
      const values = row.split(delim);

      if (values.length > 1) {
        const eachObject = headers.reduce((obj, header, i) => {
          if (values[i] === "null" || values[i] === "") {
            obj[header] = null;
          } else {
            obj[header] = values[i];
          }

          return obj;
        }, {});
        newArray.push(eachObject);
        return eachObject;
      }
      return [];
    });
    if (newArray.length > 0) {
      const result = await ApiCallGateway.password.uploadCsv(
        JSON.stringify(newArray)
      );
      // console.log(result);
      if (result === 200) {
        // setLoader(false);
        sweetAlert("Success", "Csv uploaded successfully", "success");
        passwordRefetch();
      } else {
        // setLoader(false);
        sweetAlert("Oops!", "Something went wrong", "error");
      }
    }
  };

  const uploadFile = async () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);

      const reader = new FileReader();

      reader.onload = function (e) {
        const text = e.target.result;
        processCSV(text);
      };

      reader.readAsText(selectedFile);
    }
  };
  const handleSelectUsers = (user) => {
    if (!selectedUsers.includes(user)) {
      setSelectedUsers((oldValue) => [...oldValue, user]);
    }
  };

  const removeSelectUsers = (user) => {
    if (selectedUsers.includes(user)) {
      setSelectedUsers(selectedUsers.filter((u) => u !== user));
    }
  };

  const folderFormik = useFormik({
    initialValues: {
      name: envDetais?.name,

      description: envDetais?.description,
      color: envDetais?.color,
    },
    validationSchema: addFolderschema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      console.log({ ...values, shareWith: selectedUsers });
      let res;
      res = await ApiCallGateway.folder.updateFolderEnv(
        values,
        envDetais?.envId ? envDetais?.envId : envDetais._id
      );
      addFoldertoggle();
      detailsRefetch();
    },
  });
  const shareFolderFormik = useFormik({
    initialValues: {
      folderId: "",
      shareWith: [],
      note: "",
    },
    validationSchema: sharefolderSchemaObj,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let data = [];
      // console.log({ ...values, shareWith: selectedUsers });

      for (const element of selectedUsers) {
        let a = {
          envId: values.folderId,
          shareWith: element?._id,
          sharedEmail: element?.email,
          sharedName: element?.name,
          expiryDate: null,
          note: values.note,
          isNew: !element?._id,
        };
        data.push(a);
      }

      // console.log(data, "kkk");
      const res = await ApiCallGateway.folder.shareFolderEnv(
        data,
        true
      );
      // console.log(res);
      sharetoggle();
      resetForm();
      detailsRefetch();
    },
  });
  const deleteFolder = async (id) => {
    setLoader(true);
    const res = await ApiCallGateway.folder.deleteFolderEnv(id);
    console.log(res);
    if (res?.status === 200) {
      confirmtoggle();
      detailsRefetch();
      setLoader(false);
    }
    history.goBack();
    setLoader(false);
  };
  // console.log(passwordList, envId);
  return (
    <div>
      <PageHeader
        title={envDetails?.name}
        folder_details={true}
        folderData={envDetails}
        importCSV={true}
        isback={true}
        viewType={viewType}
        setViewType={(e) => setViewType(e)}
        splitIcon={true}
        selectAll={() => handleSelectAll()}
        addpasswordToggle={() => {
          passwordModeltoggle();
        }}
        csvModaltoggle={() => csvModaltoggle()}
        shareFoldertoggle={(item) => {
          // console.log(item);
          sharetoggle();

          setEnvDetails(item._id);
          getEnvAccessList(item._id, item?.folderId);
          shareFolderFormik.setFieldValue("folderId", item._id);
        }}
        editFoldertoggle={(details) => {
          setEnvDetails(details);
          addFoldertoggle();
        }}
        confirmFoldertoggle={(details) => {
          confirmtoggle();
          setEnvDetails(details);
        }}
      />
      <PasswordHelper
        passwordList={passwordList}
        viewType={viewType}
        sharePasswordFormik={sharePasswordFormik}
        onRefetch={() => passwordRefetch()}
        isShared={false}
        passwordModeltoggle={() => passwordModeltoggle()}
        passweordDetails={(data) => {
          // console.log(data);
          setpwDetails(data);
          setPasswordType(data?.passwordType);
        }}
        setEditPassword={() => setPasswordEdit(true)}
      />
      <PasswordForm
        isEdit={passwordEdit}
        passwordModaltoggle={() => passwordModeltoggle()}
        passwordModal={passwordModal}
        numberCheck={numberCheck}
        numberChecktoggle={() => setNumberCheck(!numberCheck)}
        uppercaseCheck={uppercaseCheck}
        uppercaseChecktoggle={() =>
          setUppercaseCheck(!uppercaseCheck)
        }
        lowercaseCheck={lowercaseCheck}
        lowercaseChecktoggle={() =>
          setLowercaseCheck(!lowercaseCheck)
        }
        symbolCheck={symbolCheck}
        symbolChecktoggle={() => setSymbolCheck(!symbolCheck)}
        passwordLength={passwordLength}
        setPasswordLength={(e) => setPasswordLength(e)}
        onRefresh={() =>
          generatePassword(
            uppercaseCheck,
            lowercaseCheck,
            numberCheck,
            symbolCheck
          )
        }
        passwordVisible={passwordVisible}
        togglePassword={() => togglePassword()}
        generatePassVisible={generatePassVisible}
        toggleGeneratePass={() => toggleGeneratePass()}
        // passwordValue={password}
        passwordType={passwordType}
        setPasswordType={(e) => setPasswordType(e)}
        formik={passwordFormik}
        handleFileChange={(e) => handleFileChange(e)}
      />
      <ImportCSV
        csvModal={csvModal}
        csvModaltoggle={() => csvModaltoggle()}
        csvDownload={(pwType) => downloadCSVWithHeaders(pwType)}
        onFileChange={(file) => handleCSVFileChange(file)}
        uploadCsv={uploadFile}
      />
      <ShareModal
        md={true}
        isEnv={true}
        shareModal={shareModal}
        shareModaltoggle={sharetoggle}
        formik={shareFolderFormik}
        handleSelectUsers={(id) => handleSelectUsers(id)}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
      />
      <AddFolderModal
        title={"Edit Env/Subfolder"}
        addFolderModal={addFolderModal}
        addFoldertoggle={addFoldertoggle}
        isEdit={true}
        formik={folderFormik}
        handleSelectUsers={(id) => handleSelectUsers(id)}
        removeSelectUsers={(id) => removeSelectUsers(id)}
        selectedUsers={selectedUsers}
      />
      <ConfirmModal
        confirmModal={confirmModal}
        confirmModaltoggle={confirmtoggle}
        passwordId={envDetails}
        onProceed={(data) => deleteFolder(data?._id)}
      />

      {passwordList?.data?.length < 1 ? <NoData /> : null}
    </div>
  );
}

export default EnvironmentDetails;
